import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organogram',
  templateUrl: './organogram.component.html',
  styleUrls: ['./organogram.component.scss']
})
export class OrganogramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
